import Vue from 'vue'
import Vuex from 'vuex'
import { modal } from './store/modal.module'
import { notifications } from './store/notifications.module'
import { geolocation } from './store/geolocation.module'
import { deliveries } from './store/deliveries.module'
import { deliveriesPlanning } from './store/deliveriesPlanning.module'
import { navbar } from './store/navbar.module'
import { complaints } from './store/complaints.module'
import { homeOrders } from './store/homeOrders.module'
import { auth } from './store/auth.module'
import { codeSearch } from './store/codeSearch.module'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        modal,
        notifications,
        geolocation,
        deliveries,
        navbar,
        deliveriesPlanning,
        complaints,
        homeOrders,
        auth,
        codeSearch
    }
})
